import React from 'react';
import PropTypes from 'prop-types';

import { layout } from 'styled-system';

import styled from 'styled-components';

const Box = styled.div`
    ${layout}
`;

const Spacer = ({ size = 'none' }) => {
    return <Box height={size} width={size} />;
};

Spacer.propTypes = {
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default Spacer;
